export default __webpack_public_path__ + "static/5_31-6de5887f61c5e7e35263197952a5322e.png";